import { TYPES } from '@/entities/fields'
import i18n from '@/lang/i18n'

const DATAGRID_CONFIG = {
    hasInputFilter: false,
    filterable: false,
    sideBar: false,
    cleanFiltersButton: false,
    fitResponsive: true,
    editable: false,
}

const COLUMNS = [
    {
        headerName: i18n.t('schema.matchs.headers.type'),
        field: 'type',
        type: TYPES.SELECT,
        selectGroup: 'types',
        width: 150,
        suppressSizeToFit: true,
    },
    {
        headerName: i18n.t('schema.matchs.headers.matchTo'),
        field: 'matchTo',
        type: TYPES.STRING,
    },
    {
        headerName: i18n.t('schema.matchs.headers.matchToFields'),
        field: 'fields',
        type: TYPES.STRING,
        selectGroup: 'fields',
    },
    {
        headerName: i18n.t('schema.matchs.headers.matchFrom'),
        field: 'matchFrom',
        type: TYPES.STRING,
    },
    {
        headerName: i18n.t('schema.matchs.headers.entity'),
        field: 'against.entity',
        type: TYPES.STRING,
    },
    {
        headerName: i18n.t('schema.matchs.headers.matchFromFields'),
        field: 'against.fields',
        type: TYPES.SELECT,
    },
    {
        headerName: i18n.t('schema.matchs.headers.autoMatch'),
        field: 'autoMatch',
        type: TYPES.BOOL,
    },
    {
        headerName: i18n.t('schema.matchs.headers.locked'),
        field: 'locked',
        type: TYPES.BOOL,
    },
]

export default {
    config: DATAGRID_CONFIG,
    columns: COLUMNS,
}
